import Vue from 'vue'
import moment from 'moment';
import VueMomentJS from 'vue-momentjs';
import VueLodash from 'vue-lodash';
import VueScrollTo from 'vue-scrollto';
import VueLadda from 'vue-ladda/src/vue-ladda.vue';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import VeeValidate from 'vee-validate';

import 'font-awesome/scss/font-awesome.scss';
import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css'

import App from './App.vue'

Vue.component('vue-ladda', VueLadda);
Vue.use(VueMomentJS, moment);
Vue.use(VueLodash);
Vue.prototype.moment = moment;

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: -103, //negative value of header height
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

Vue.filter('formatDate', (value, format = 'DD/MM/YYYY HH:mm') => moment(value).format(format));

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

Vue.use(VeeValidate, {
    validity: true,
    validator: 'new'
});

Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
}).$mount('#app');
